// 管理后台 RBAC 接口封装（仅依赖本模块 request.js，不引用其他业务模块）。
import request, { setToken, setProfile, clearAuth, getProfile } from './request'

export const authApi = {
  async login (loginName, password) {
    const data = await request.post('/yljx/admin/auth/login', {
      login_name: loginName,
      password
    })
    setToken(data.token)
    setProfile(data.administrator)
    return data
  },
  logout () {
    try {
      request.post('/yljx/admin/auth/logout')
    } catch (e) { /* 忽略登出接口异常 */ }
    clearAuth()
  },
  profile () {
    return getProfile()
  }
}

const crud = (resource) => ({
  list: () => request.get(`/yljx/admin/${resource}`),
  create: (payload) => request.post(`/yljx/admin/${resource}`, payload),
  update: (id, payload) => request.put(`/yljx/admin/${resource}/${id}`, payload),
  remove: (id) => request.delete(`/yljx/admin/${resource}/${id}`)
})

export const administratorsApi = crud('administrators')
export const rolesApi = crud('roles')
export const permissionsApi = crud('permissions')
export const menusApi = crud('menus')
export const policiesApi = crud('policies')
